import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
  cilArrowRight,
  cilArrowTop,
  cilArrowBottom,
  cilBan,
  cilBasket,
  cilBell,
  cilBriefcase,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCreditCard,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cibAddthis,
  cilTrash,
  cilClone,
  cilCog,
  cilAccountLogout,
  cilNewspaper,
  cilFilterX,
  cilSave,
  cilArrowLeft,
  cilReload,
  cilPlus,
  cilCopy,
  cilSearch,
  cilZoomIn,
  cilThumbDown,
  cilPlaylistAdd,
  cilCash,
  cibCashapp,
  cilClock,
  cilFindInPage,
  cilUserUnfollow,
  cilArrowThickTop,
  cilArrowThickBottom,
  cilNotes,
  cilCloudUpload,
  cilPrint,
  cilNoteAdd,
} from '@coreui/icons';

const icons = {
  cilArrowRight,
  cilArrowTop,
  cilArrowBottom,
  cilBan,
  cilBasket,
  cilBell,
  cilBriefcase,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCreditCard,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibAddthis,
  cilTrash,
  cilClone,
  cilCog,
  cilAccountLogout,
  cilNewspaper,
  cilFilterX,
  cilSave,
  cilArrowLeft,
  cilReload,
  cilPlus,
  cilCopy,
  cilSearch,
  cilZoomIn,
  cilThumbDown,
  cilPlaylistAdd,
  cilCash,
  cibCashapp,
  cilClock,
  cilFindInPage,
  cilUserUnfollow,
  cilArrowThickTop,
  cilArrowThickBottom,
  cilNotes,
  cilCloudUpload,
  cilPrint,
  cilNoteAdd,
};

export default icons;
